/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    ChildCare,
    EmojiTransportationOutlined,
    FlagOutlined,
    MailOutline,
    MapsHomeWorkOutlined,
    Person, PersonAdd,
    PhoneAndroid, SellOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTextoBoton from "../../../Modulo_formularios/Componentes/IngresoTextoBoton";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import {useEffect, useState} from "react";
import IngresoFechaExcluyendo from "../../../Modulo_formularios/Componentes/IngresoFechaExcluyendo";
import {FECHACHECKIN, FECHACHECKOUT, MOTIVOS} from "../../../Modulo_Motor_Reservas/Constantes";
import {collection, limit, orderBy, query, where} from "firebase/firestore";
import {obtenerColeccionQuery} from "../../../Servicios/BD/obtenerColeccionQuery";
import {fire} from "../../../fire";
import {TIPOCLIENTE} from "../../../Constantes";

const Formulario_Reserva_Datos = ({...props}) => {
    const [fechaInicio, setFechaInicio] = useState(new Date())
    const [cargando, setCargando] = useState(false)

    const buscar = async () => {
        setCargando(true)
        let palabra = props.props.getValues('cc')
        if (palabra) {
            let q = query(collection(fire, 'reservas'), where('cc', '==', palabra), orderBy('fecha', 'desc'), limit(1))
            let dox = await obtenerColeccionQuery(q)
            if (dox.res && dox.data[0]) {
                poblarCliente(dox.data[0])
            }
            setCargando(false)
        } else {
            setCargando(false)
        }

    }

    const poblarCliente = (data) => {

        props.props.setValue('tipoCc', data.tipoCc)
        props.props.setValue('nombres', data.nombres)
        props.props.setValue('apellidos', data.apellidos)
        props.props.setValue('cc', data.cc)
        props.props.setValue('ccPrincipal', data.ccPrincipal)
        props.props.setValue('celular', data.celular)
        props.props.setValue('ciudad', data.ciudad)
        props.props.setValue('ciudadProcendencia', data.ciudadProcendencia)
        props.props.setValue('correo', data.correo)
        props.props.setValue('motivo', data.motivo)


    }


    useEffect(() => {
        let fechaEscogida = props.props.getValues(FECHACHECKIN)
        setFechaInicio(fechaEscogida)


    }, [props.props.watch(FECHACHECKIN)]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Identificacion</Typography>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo Id'} dato={'tipoCc'} {...props}
                                   opciones={['C.C', 'T.E']}
                    />
                </Grid>

                <Grid container size={{xs: 8, sm: 8, md: 8}}>
                    <IngresoTextoBoton Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}
                                       click={buscar} cargando={cargando}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos del huesped</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Ciudad Residencia'} dato={'ciudad'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos de reserva</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={EmojiTransportationOutlined} nombre={'Ciudad de procedencia'}
                                  dato={'ciudadProcendencia'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Motivo de viaje'}
                                   dato={'motivo'} {...props} opciones={MOTIVOS}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={SellOutlined} nombre={'Tipo de cliente'} dato={'tipoCliente'}
                                   opciones={TIPOCLIENTE} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Person} nombre={'num Adultos'} dato={'numAcompanantes'}
                                  type={'number'} {...props} opciones={[1,2,3,4,5,6]} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={ChildCare} nombre={'Num Niños'} dato={'numNinos'}
                                  type={'number'} {...props} opciones={[0,1,2,3,4,5,6]} />
                </Grid>


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoFecha nombre={'Fecha de Ingreso'} dato={FECHACHECKIN} {...props} />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoFechaExcluyendo nombre={'Fecha de Salida'} dato={FECHACHECKOUT} {...props}
                                            fechaInicioExclusion={new Date(new Date().getFullYear() - 1, 1, 1)}
                                            fechaFinalExclusion={fechaInicio}/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Datos